export class GetPendingApplicationsRequest {
  KeywordSearches: string[];
  PageNumber: number;
  ItemsPerPage: number;
  Sorting: number;
  StatusSort: number;
}
